// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   SuiviDeCommandeMSV2 — feuille de style UNIQUE de la vue prestataire commande-ms.
   Copie autonome (PAS un import) du CSS de la case soeur presta commande-bc (.scbc) :
   tout est porte par la racine .scms (namespace miroir), pour une parite visuelle exacte
   sans fuite globale ni dependance accidentelle. Les feuilles lourdes reutilisees par les
   contenus d'onglets conserveront leur propre CSS — la frontiere est au niveau du contenu
   des onglets, exactement comme cote BC presta et acheteur MS.
   ============================================================================= */

/* --- Layout page ---------------------------------------------------------- */
.scms {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.scms__content {
  padding: 0 6rem 2rem 6rem;
}

.scms__tab-content {
  padding: 2rem 0;
  min-height: 500px;
}

@media print {
  .scms__tab-content {
    padding: 0;
  }
}

/* --- Etats chargement / erreur / vide ------------------------------------- */
.scms__loading,
.scms__empty,
.scms__error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 1.8rem;
  color: #374151;
  text-align: center;
}

.scms__error p {
  color: #dc2626;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}

/* --- Barre d'onglets ------------------------------------------------------ */
.scms__tab-nav {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
}

@media print {
  .scms__tab-nav {
    margin-bottom: 0 !important;
  }
}

.scms__tab-nav-left {
  display: flex;
  gap: 2rem;
}

.scms__tab-button {
  position: relative;
  background: none;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.4rem;
  color: #6b7280;
  cursor: pointer;
}

.scms__tab-button:hover {
  color: #2c3948;
}

.scms__tab-button.active {
  color: #2c3948;
  font-weight: 500;
}

.scms__tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #f97316;
}

.scms__tab-button.inactive,
.scms__tab-button.disabled {
  color: #a1a1aa;
  cursor: not-allowed;
  opacity: 0.6;
}

.scms__tab-button.inactive::after,
.scms__tab-button.disabled::after {
  display: none;
}

.scms__tab-button.inactive::before,
.scms__tab-button.disabled::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
  padding: 5px 10px;
  background-color: #333333;
  color: #ffffff;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 1.2rem;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  pointer-events: none;
  z-index: 100;
}

.scms__tab-button.inactive:hover::before,
.scms__tab-button.disabled:hover::before {
  opacity: 1;
  visibility: visible;
}

/* Badge de messages non-lus (onglets Q&R / Messagerie). Pastille orange compacte collee au libelle. */
.scms__tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.8rem;
  height: 1.8rem;
  margin-left: 0.6rem;
  padding: 0 0.5rem;
  border-radius: 999px;
  background-color: #f97316;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1;
  vertical-align: middle;
}

/* =============================================================================
   Skeleton de chargement (shimmer). CSS auto-contenu, prefixe .scms-sk, geometrie calee sur le
   vrai rendu (banniere SuiviHeader + 6 onglets + contenu) pour eviter le saut de layout.
   ============================================================================= */
@keyframes scms-sk-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.scms-skeleton {
  pointer-events: none;
}

.scms-sk {
  display: block;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: scms-sk-shimmer 1.4s ease-in-out infinite;
  border-radius: 6px;
}

/* Banniere : meme geometrie que SuiviHeader (.suivi-commande-title : padding 2rem 4rem, marge
   basse 2rem, fond sombre) pour une hauteur identique au vrai header. */
.scms-sk-banner {
  padding: 2rem 4rem;
  margin-bottom: 2rem;
  background: #1f2937;
}

/* Sur fond sombre, les blocs shimmer sont clairs. */
.scms-sk-banner .scms-sk {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);
  background-size: 200% 100%;
}

.scms-sk-back { padding: 1rem 0; }
.scms-sk-back .scms-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }

.scms-sk-h1 { height: 4.1rem; display: flex; align-items: center; }
.scms-sk-h1 .scms-sk { width: 45%; height: 2.4rem; }

.scms-sk-h2 { height: 3.1rem; display: flex; align-items: center; }
.scms-sk-h2 .scms-sk { width: 32%; height: 1.8rem; }

.scms-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }
.scms-sk-subtitle .scms-sk { width: 38%; height: 1.4rem; }

.scms-sk-statusline { height: 2rem; display: flex; align-items: center; }
.scms-sk-statusline .scms-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }

/* Barre d'onglets : mime .scms__tab-nav (border-bottom, marge basse 3rem). */
.scms-sk-tabs {
  display: flex;
  gap: 2rem;
  border-bottom: 1px solid #e5e7eb;
  padding: 1rem 0;
  margin-bottom: 3rem;
}
.scms-sk-tab { width: 80px; height: 1.6rem; }

/* Contenu : empilement de blocs (le padding vient de .scms__tab-content). */
.scms-sk-content {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.scms-sk-block { width: 100%; height: 90px; }
.scms-sk-block--lg { height: 220px; }
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviDeCommandeMSV2/SuiviDeCommandeMSV2.css"],"names":[],"mappings":"AAAA;;;;;;;kFAOkF;;AAElF,+EAA+E;AAC/E;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,+EAA+E;AAC/E;;;EAGE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA,sGAAsG;AACtG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;kFAGkF;AAClF;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yEAAyE;EACzE,0BAA0B;EAC1B,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;wEACwE;AACxE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,+HAA+H;EAC/H,0BAA0B;AAC5B;;AAEA,gBAAgB,eAAe,EAAE;AACjC,gCAAgC,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAEnF,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;;AAEnD,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;;AAEnD,oBAAoB,cAAc,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC7F,6BAA6B,UAAU,EAAE,cAAc,EAAE;;AAEzD,sBAAsB,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACxE,+BAA+B,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAElF,6EAA6E;AAC7E;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AACA,eAAe,WAAW,EAAE,cAAc,EAAE;;AAE5C,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,qBAAqB,aAAa,EAAE","sourcesContent":["/* =============================================================================\n   SuiviDeCommandeMSV2 — feuille de style UNIQUE de la vue prestataire commande-ms.\n   Copie autonome (PAS un import) du CSS de la case soeur presta commande-bc (.scbc) :\n   tout est porte par la racine .scms (namespace miroir), pour une parite visuelle exacte\n   sans fuite globale ni dependance accidentelle. Les feuilles lourdes reutilisees par les\n   contenus d'onglets conserveront leur propre CSS — la frontiere est au niveau du contenu\n   des onglets, exactement comme cote BC presta et acheteur MS.\n   ============================================================================= */\n\n/* --- Layout page ---------------------------------------------------------- */\n.scms {\n  min-height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.scms__content {\n  padding: 0 6rem 2rem 6rem;\n}\n\n.scms__tab-content {\n  padding: 2rem 0;\n  min-height: 500px;\n}\n\n@media print {\n  .scms__tab-content {\n    padding: 0;\n  }\n}\n\n/* --- Etats chargement / erreur / vide ------------------------------------- */\n.scms__loading,\n.scms__empty,\n.scms__error {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-size: 1.8rem;\n  color: #374151;\n  text-align: center;\n}\n\n.scms__error p {\n  color: #dc2626;\n  font-size: 1.6rem;\n  margin-bottom: 1rem;\n}\n\n/* --- Barre d'onglets ------------------------------------------------------ */\n.scms__tab-nav {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n@media print {\n  .scms__tab-nav {\n    margin-bottom: 0 !important;\n  }\n}\n\n.scms__tab-nav-left {\n  display: flex;\n  gap: 2rem;\n}\n\n.scms__tab-button {\n  position: relative;\n  background: none;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1.4rem;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.scms__tab-button:hover {\n  color: #2c3948;\n}\n\n.scms__tab-button.active {\n  color: #2c3948;\n  font-weight: 500;\n}\n\n.scms__tab-button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #f97316;\n}\n\n.scms__tab-button.inactive,\n.scms__tab-button.disabled {\n  color: #a1a1aa;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.scms__tab-button.inactive::after,\n.scms__tab-button.disabled::after {\n  display: none;\n}\n\n.scms__tab-button.inactive::before,\n.scms__tab-button.disabled::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 5px;\n  padding: 5px 10px;\n  background-color: #333333;\n  color: #ffffff;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-size: 1.2rem;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s, visibility 0.3s;\n  pointer-events: none;\n  z-index: 100;\n}\n\n.scms__tab-button.inactive:hover::before,\n.scms__tab-button.disabled:hover::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Badge de messages non-lus (onglets Q&R / Messagerie). Pastille orange compacte collee au libelle. */\n.scms__tab-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.8rem;\n  height: 1.8rem;\n  margin-left: 0.6rem;\n  padding: 0 0.5rem;\n  border-radius: 999px;\n  background-color: #f97316;\n  color: #ffffff;\n  font-size: 1.1rem;\n  font-weight: 600;\n  line-height: 1;\n  vertical-align: middle;\n}\n\n/* =============================================================================\n   Skeleton de chargement (shimmer). CSS auto-contenu, prefixe .scms-sk, geometrie calee sur le\n   vrai rendu (banniere SuiviHeader + 6 onglets + contenu) pour eviter le saut de layout.\n   ============================================================================= */\n@keyframes scms-sk-shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n.scms-skeleton {\n  pointer-events: none;\n}\n\n.scms-sk {\n  display: block;\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: scms-sk-shimmer 1.4s ease-in-out infinite;\n  border-radius: 6px;\n}\n\n/* Banniere : meme geometrie que SuiviHeader (.suivi-commande-title : padding 2rem 4rem, marge\n   basse 2rem, fond sombre) pour une hauteur identique au vrai header. */\n.scms-sk-banner {\n  padding: 2rem 4rem;\n  margin-bottom: 2rem;\n  background: #1f2937;\n}\n\n/* Sur fond sombre, les blocs shimmer sont clairs. */\n.scms-sk-banner .scms-sk {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);\n  background-size: 200% 100%;\n}\n\n.scms-sk-back { padding: 1rem 0; }\n.scms-sk-back .scms-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }\n\n.scms-sk-h1 { height: 4.1rem; display: flex; align-items: center; }\n.scms-sk-h1 .scms-sk { width: 45%; height: 2.4rem; }\n\n.scms-sk-h2 { height: 3.1rem; display: flex; align-items: center; }\n.scms-sk-h2 .scms-sk { width: 32%; height: 1.8rem; }\n\n.scms-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }\n.scms-sk-subtitle .scms-sk { width: 38%; height: 1.4rem; }\n\n.scms-sk-statusline { height: 2rem; display: flex; align-items: center; }\n.scms-sk-statusline .scms-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }\n\n/* Barre d'onglets : mime .scms__tab-nav (border-bottom, marge basse 3rem). */\n.scms-sk-tabs {\n  display: flex;\n  gap: 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 1rem 0;\n  margin-bottom: 3rem;\n}\n.scms-sk-tab { width: 80px; height: 1.6rem; }\n\n/* Contenu : empilement de blocs (le padding vient de .scms__tab-content). */\n.scms-sk-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n.scms-sk-block { width: 100%; height: 90px; }\n.scms-sk-block--lg { height: 220px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
